import {
    Marker,
    Popup,
} from 'react-leaflet'

import MapPointGraphic from '../../assets/map/map-point.png'
import MapPointUpcomingGraphic from '../../assets/map/map-point-upcoming.png'
import MapPointBrightGraphic from '../../assets/map/map-point-bright.png'
import MapPointUpcomingBrightGraphic from '../../assets/map/map-point-upcoming-bright.png'
import MapPointPreviewGraphic from '../../assets/map/map-point-preview.svg'

const L = require("leaflet")

// Icon for points

const iconSize = [16, 16]

const defaultPointIcon = new L.Icon({
    iconUrl: MapPointGraphic,
    iconSize: iconSize,
    iconAnchor: [8, 16],
    popupAnchor: [4, 4],
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null
})

const defaultUpcomingPointIcon = new L.Icon({
    iconUrl: MapPointUpcomingGraphic,
    iconSize: iconSize,
    iconAnchor: [8, 16],
    popupAnchor: [4, 4],
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null
})

const defaultBrightPointIcon = new L.Icon({
  iconUrl: MapPointBrightGraphic,
  iconSize: iconSize,
  iconAnchor: [8, 16],
  popupAnchor: [4, 4],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null
})

const defaultUpcomingBrightPointIcon = new L.Icon({
  iconUrl: MapPointUpcomingBrightGraphic,
  iconSize: iconSize,
  iconAnchor: [8, 16],
  popupAnchor: [4, 4],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null
})

const previewPointIcon = new L.Icon({
    iconUrl: MapPointPreviewGraphic,
    iconSize:     [38, 95], // size of the icon
    iconAnchor:   [21, 61], // point of the icon which will correspond to marker's location
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null
})

export function StationMarker(props) {
    const { point, variant } = props
    
    const getIconByVariant = () => {
      if (variant === "default") return defaultPointIcon;
      if (variant === "upcoming") return defaultUpcomingPointIcon;
      if (variant === "default-bright") return defaultBrightPointIcon;
      if (variant === "upcoming-bright") return defaultUpcomingBrightPointIcon;
      if (variant === "preview") return previewPointIcon;
      return null;
    };
  
    const icon = getIconByVariant();
  
    return (
      <Marker position={point.position} icon={icon}>
        <Popup>
          {point.stationName}
        </Popup>
      </Marker>
    );
}
